import { render } from "./IsoUniversity.vue?vue&type=template&id=656cd50c&scoped=true"
import script from "./IsoUniversity.vue?vue&type=script&lang=js"
export * from "./IsoUniversity.vue?vue&type=script&lang=js"

import "./IsoUniversity.vue?vue&type=style&index=0&id=656cd50c&scoped=true&lang=css"
import "./IsoUniversity.vue?vue&type=style&index=1&id=656cd50c&scoped=true&lang=css"

import exportComponent from "C:\\projects\\frontend\\inso-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-656cd50c"]])

export default __exports__